import { Trash } from 'lucide-react';
import styled, { css } from 'styled-components';
import { Button } from '@/components/ui/button';

interface ButtonIcon {
	$outlined?: boolean;
}

const outlinedStyled = `
	svg {
		height: 20px;
		width: 20px;
	}
`;

const defaultStyles = `
	svg {
		width: 25px;
	}
`;

const StyledIcon = styled.button<ButtonIcon>`
	align-items: center;
	background-color: ${(props) => (props.$outlined ? ' rgba(230, 76, 101, 0.5)' : 'transparent')};
	border-radius: 50%;
	border: none;
	cursor: pointer;
	display: inline-flex;
	padding: var(--spacing-2);
	transition: background-color 0.3s;

	&[disabled] {
		opacity: 0.3;
		pointer-events: none;
	}

	${(props) => {
		let style = defaultStyles;
		if (props.$outlined) {
			style = outlinedStyled;
		}
		return css`
			${style}
		`;
	}}

	&:active,
	&:focus-visible,
	&:hover {
		background-color: ${(props) =>
			props.$outlined ? 'rgba(230, 76, 101, 1)' : 'rgba(230, 76, 101, 0.5);'};
		outline: none;
	}
`;

interface IconProps {
	passedEvent(): void;
	outlined?: boolean;
	className?: string;
	disabled?: boolean;
}

const TrashCanIcon = ({ passedEvent, className = '', disabled = false }: IconProps) => (
	<Button
		variant="outline"
		size="xs"
		onClick={passedEvent}
		disabled={disabled}
		className={`rounded-full text-red-700 border-red-700 hover:bg-red-700 hover:text-white ${className}`}
	>
		<Trash className="w-4 h-4" />
		<span className="sr-only">Delete Icon</span>
	</Button>
);

export default TrashCanIcon;
